import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
} from "@/pages/settings/components/settings-integration-layout";
import { SettingsDebugSandboxContent } from "@/pages/settings/components/debug-sandbox/settings-debug-sandbox-content";
import { FC } from "react";

export const SettingsDebugSandboxPage: FC = () => {
  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader breadcrumb="Debug" title="Debug sandbox" />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <SettingsDebugSandboxContent />
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
};
